export { default } from '@/modules/JobListingJobCardList/components/JobListingJobCardList/JobListingJobCardList';
